export const bannedBaseColumnNames = ['name'] as const;
export const bannedGeocoordinateColumnNames = ['phone', 'ph#'] as const;
